import * as React from 'react';
import { ReactElement } from 'react';

const IconNotIncluded = ({ ...props }): ReactElement => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M4 12H20"
        stroke="#10284B"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default IconNotIncluded;
